<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="2" md="3" sm="4">
        <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.start_day" label="开始日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined>
              <template v-slot:label>开始日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.start_day_menu.save(queryForm.start_day); start_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" lg="2" md="3" sm="4">
        <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.end_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.end_day" label="结束日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined>
              <template v-slot:label>结束日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.end_day_menu.save(queryForm.end_day); end_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" lg="2" md="2" sm="4">
        <v-text-field v-model="queryForm.postline" label="线路" outlined dense clearable>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="2" md="2" sm="4">
        <v-text-field v-model="queryForm.driver" label="司机/车牌号" outlined dense clearable>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="3" md="2" sm="4">
        <a-space>
          <v-btn @click="getdata" color="primary" dark tile>
            <v-icon small>mdi-magnify</v-icon>查询
          </v-btn>
          <v-btn @click="downloadbill" color="indigo" dark tile>
            <v-icon small>mdi-download</v-icon>下载账单
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <p v-if="total" class="text-h6">
      合计：
      <span class="success--text"> 收入({{ total.income }}) </span>,
      <span class="error--text"> 支出({{ total.cost }}) </span>,
      <span :class="{ 'success--text': total.profit > 0, 'error--text': total.profit < 0 }">
        利润({{ total.fprofit }})
      </span>
    </p>
    <v-card tile>
      <a-table size="small" :columns="headers" :data-source="list" row-key="_id" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }">
        <template slot="index">
          {{ list.length }}
        </template>
        <template slot="driver">
          <p>司机姓名</p>
          <p>司机电话</p>
          <p>车牌号</p>
        </template>
        <template slot="income">
          <p class="success--text">合计收入</p>
        </template>
        <template slot="cost">
          <p class="error--text">合计成本</p>
        </template>
        <template slot="index" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="driver" slot-scope="text, record">
          <p>{{ record.driver_name }}</p>
          <p>{{ record.driver_mobile }}</p>
          <p>{{ record.carnumber }}</p>
        </template>
        <template slot="income" slot-scope="text, record">
          <p class="success--text">
            {{ record.income }}
          </p>
        </template>
        <template slot="cost" slot-scope="text, record">
          <p class="error--text">
            {{ record.cost }}
          </p>
        </template>
        <template slot="profit" slot-scope="text, record">
          <p :class="{
            'font-weight-bold': true,
            'error--text': record.profit < 0,
            'success--text': record.profit > 0
          }">
            {{ record.profit }}
          </p>
        </template>
      </a-table>
    </v-card>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "FinanceBYFinancialBill",
  data() {
    return {
      pages: [
        { text: "20/页", value: 20 },
        { text: "50/页", value: 50 },
        { text: "100/页", value: 100 },
        { text: "200/页", value: 200 },
        { text: '500/页', value: 500 },
        { text: '1000/页', value: 1000 },
      ],
      queryForm: {
        start_day: "",
        end_day: "",
        postline: "",
        driver: ""
      },
      start_day_menu: false,
      end_day_menu: false,
      headers: [
        { dataIndex: "index", slots: { title: "index" }, scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "发货日期", dataIndex: "date", scopedSlots: { customRender: "date" }, width: 120, align: "center" },
        { title: "线路", dataIndex: "postline_by", scopedSlots: { customRender: "postline_by" }, width: 120, align: "center" },
        { dataIndex: "driver", slots: { title: "driver" }, scopedSlots: { customRender: "driver" }, width: 120, align: "center" },
        { title: "收入", dataIndex: "ifee1", scopedSlots: { customRender: "ifee1" }, width: 120, align: "center" },
        { title: "卸货加点费", dataIndex: "ifee2", scopedSlots: { customRender: "ifee2" }, width: 120, align: "center" },
        { title: "卸货费", dataIndex: "ifee3", scopedSlots: { customRender: "ifee3" }, width: 120, align: "center" },
        { title: "临时加短驳车实报实销", dataIndex: "ifee4", scopedSlots: { customRender: "ifee4" }, width: 120, align: "center" },
        { dataIndex: "income", slots: { title: "income" }, scopedSlots: { customRender: "income" }, width: 120, align: "center" },
        { title: "支出", dataIndex: "cfee1", scopedSlots: { customRender: "cfee1" }, width: 120, align: "center" },
        { title: "卸货加点费", dataIndex: "cfee2", scopedSlots: { customRender: "cfee2" }, width: 120, align: "center" },
        { title: "卸货费", dataIndex: "cfee3", scopedSlots: { customRender: "cfee3" }, width: 120, align: "center" },
        { title: "临时加短驳车实报实销", dataIndex: "cfee4", scopedSlots: { customRender: "cfee4" }, width: 120, align: "center" },
        { dataIndex: "cost", slots: { title: "cost" }, scopedSlots: { customRender: "cost" }, width: 120, align: "center" },
        { title: "利润", dataIndex: "profit", scopedSlots: { customRender: "profit" }, width: 120, align: "center" },
        // { title: "利润率", dataIndex: "rate", scopedSlots: { customRender: "rate" }, width: 120, align: "center" },
      ],
      list: [],
      height: 600,
      vrules: {
        required: (value) => !!value || "不能为空"
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    total() {
      let total = {
        income: this.$d(),//收入
        cost: this.$d(),//支出
        profit: this.$d(),//利润
        fprofit: '',
      };
      for (let i = 0; i < this.list.length; i++) {
        let {
          income,
          cost,
          profit,
        } = this.list[i];
        total.income = total.income.plus(income);
        total.cost = total.cost.plus(cost);
        total.profit = total.profit.plus(profit);
      }
      total.fprofit = this.$utils.formatMoney(total.profit.toString(), 2, '');
      total.income = this.$utils.formatMoney(total.income.toString(), 2, '');
      total.cost = this.$utils.formatMoney(total.cost.toString(), 2, '');
      return total;
    },
  },
  components: {},
  watch: {

  },
  mounted() {
    this.height = window.innerHeight - 380;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 380;
    };
    this.list = [];
    let start_day = this.$dayjs().format("YYYY-MM-01");
    let end_day = this.$dayjs(new Date(`${start_day} 00:00:00.000+08:00`).getTime()).add(1, "month").subtract(1, 'second').format("YYYY-MM-DD");
    this.queryForm = {
      start_day,
      end_day,
      postline: "",
      driver: ""
    };
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/byfinancialbill/list", { ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    downloadbill() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/byfinancialbill/list", { ...this.queryForm, action: 'download' }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$download(res.data.url, res.data.name);
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
